import http from '@/utils/ajax'
import { USERSONLINE_INIT_LOADING, USERSONLINE_INIT_SUCCESS, USERSONLINE_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  usersOnline: {
    init: 0,
    menu: {},
    usersOnline: null,
    lastUpdated: null
  }
}

const getters = {

}

const actions = {
  async initUsersOnline({ commit, state }) {
    commit(USERSONLINE_INIT_LOADING)
    const apiUrl = state.permitWidgets.usersOnline
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const data = {
          menu: menu,
          usersOnline: result.data.usersOnline
        }
        commit(USERSONLINE_INIT_SUCCESS, data)
      } catch (error) {
        commit(USERSONLINE_INIT_FAIL)
      }
    } else {
      commit(USERSONLINE_INIT_FAIL)
    }
  }
}

const mutations = {
  [USERSONLINE_INIT_LOADING](state) {
    state.usersOnline.init = 0
  },
  [USERSONLINE_INIT_SUCCESS](state, data) {
    const { usersOnline } = state
    usersOnline.menu = data.menu
    usersOnline.init = 1
    usersOnline.lastUpdated = new Date()
    usersOnline.usersOnline = data.usersOnline
  },
  [USERSONLINE_INIT_FAIL](state) {
    state.usersOnline.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
